export default __webpack_public_path__ + "static/media/marker.79bee4cb.svg";